"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AddressEditor_1 = __importDefault(require("./AddressEditor"));
exports.default = AddressEditor_1.default;
